import type { CSSProperties } from 'react';

const TOUCH_ACTION_MANIPULATION = 'manipulation';
const TRANSPARENT_TAP_HIGHLIGHT_COLOR = 'transparent';

interface ResolveButtonStyleInput {
  disabled: boolean;
  disableHoverEffects: boolean;
  isInteractive: boolean;
  style?: CSSProperties;
}

interface StateContainerStyle {
  hover?: CSSProperties;
  pressed?: CSSProperties;
}

interface ResolveCurrentStateContainerStyleInput {
  isHovered: boolean;
  isPressed: boolean;
  stateContainerStyle?: StateContainerStyle;
}

interface ResolveContainerStyleInput {
  presetContainerStyle?: CSSProperties;
  containerStyle?: CSSProperties;
  currentStateContainerStyle?: CSSProperties;
}

export function resolveButtonStyle({
  disabled,
  disableHoverEffects,
  isInteractive,
  style,
}: ResolveButtonStyleInput): CSSProperties {
  return {
    opacity: disabled ? 0.5 : 1,
    pointerEvents: disabled ? 'none' : 'auto',
    cursor: disableHoverEffects || !isInteractive ? 'default' : undefined,
    touchAction: TOUCH_ACTION_MANIPULATION,
    WebkitTapHighlightColor: TRANSPARENT_TAP_HIGHLIGHT_COLOR,
    ...style,
  };
}

export function resolveCurrentStateContainerStyle({
  isHovered,
  isPressed,
  stateContainerStyle,
}: ResolveCurrentStateContainerStyleInput): CSSProperties | undefined {
  if (isPressed) {
    return stateContainerStyle?.pressed;
  }

  if (isHovered) {
    return stateContainerStyle?.hover;
  }

  return undefined;
}

export function resolveContainerStyle({
  presetContainerStyle,
  containerStyle,
  currentStateContainerStyle,
}: ResolveContainerStyleInput): CSSProperties {
  if (presetContainerStyle) {
    return {
      ...presetContainerStyle,
      ...containerStyle,
      ...currentStateContainerStyle,
    };
  }

  return {
    ...containerStyle,
    ...currentStateContainerStyle,
  };
}
